import React from 'react';
import PropTypes from 'prop-types';

import {ImageSharp} from "@mui/icons-material";

import ProductStatusBadge from "./components/ProductStatusBadge";
import ProductVisualScoring from "./components/ProductVisualScoring";

ProductImage.propTypes = {
    image: PropTypes.string,
    status: PropTypes.bool,
    visualScore: PropTypes.number,
    validated: PropTypes.bool
};

function ProductImage({image, status, visualScore, validated = true}) {
    return (
        <div style={{ height: '336px', position: 'relative' }}>
            <div style={{
                position: 'absolute',
                right: '12px',
                top: '12px',
                display: 'flex',
                gap: '8px',
                alignItems: 'center'
            }}>
                <ProductVisualScoring score={visualScore} validated={validated} />
                <ProductStatusBadge status={status} />
            </div>
            {image ? (
                <img
                    src={image}
                    alt={'product image'}
                    style={{
                        height: '100%',
                        width: '100%',
                        objectFit: 'cover',
                        borderRadius: '8px'
                    }}
                />
            ) : (
                <ImageSharp color={"disabled"} sx={{width: '100%', height: '100%'}}/>
            )}
        </div>
    );
}

export default ProductImage;
